import { FilterBase } from './FilterBase';


export class FilterFleet extends FilterBase {
        
    public onGoing:boolean
    public simulated:boolean
        
    constructor({onGoing = false,simulated = false,...args} = {}) { 
        super(args)               
        this.onGoing = onGoing
        this.simulated = simulated
    }
}
